import { Controller } from "@hotwired/stimulus";

export default class UIFilter extends Controller {
  static targets = ["source", "item", "noResults"];

  filter() {
    const filterTerm = this.sourceTarget.value.toLowerCase();
    let visibleCount = 0;
    let excludedCount = 0;

    this.sections().forEach(({ header, items }) => {
      // Matching a header keeps its whole group, so searching a group name doesn't strand the header.
      const headerMatched = header !== null && this.matches(header, filterTerm);
      let anyVisible = false;

      items.forEach((item) => {
        // An excluded item stays hidden whatever the search term.
        const isExcluded = item.dataset.uiFilterExcluded === "true";
        const isVisible = !isExcluded && (headerMatched || this.matches(item, filterTerm));
        item.classList.toggle("hidden", !isVisible);

        if (isExcluded) excludedCount++;
        if (isVisible) {
          visibleCount++;
          anyVisible = true;
        }
      });

      // A header on its own isn't a result, so it follows whether anything under it survived.
      if (header !== null) header.classList.toggle("hidden", !anyVisible);
    });

    if (this.hasNoResultsTarget) {
      // A blank search reports nothing unless exclusions are what emptied the list.
      const nothingToReport =
        visibleCount > 0 || (filterTerm === "" && excludedCount === 0);
      this.noResultsTarget.classList.toggle("hidden", nothingToReport);
    }
  }

  // Rows are a flat list: a header owns every row after it until the next header. Callers that
  // mark no headers get a single group, which filters row by row as before.
  sections() {
    const sections = [{ header: null, items: [] }];
    if (this.hasItemTarget) {
      this.itemTargets.forEach((element) => {
        if (element.dataset.uiFilterHeader === "true") {
          sections.push({ header: element, items: [] });
        } else {
          sections.at(-1).items.push(element);
        }
      });
    }
    return sections;
  }

  matches(element, filterTerm) {
    return element.innerText.toLowerCase().includes(filterTerm);
  }
}
